import { render } from "./EditDocumentReferences.vue?vue&type=template&id=47bb8eba&ts=true"
import script from "./EditDocumentReferences.ts?vue&type=script&lang=ts&external"
export * from "./EditDocumentReferences.ts?vue&type=script&lang=ts&external"

import "./EditDocumentReferences.vue?vue&type=style&index=0&id=47bb8eba&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__